// eslint-disable-next-line no-shadow
enum Role {
	ADMIN = "ROLE_ADMIN",
	USER = "ROLE_USER",
	COMPANY = "ROLE_COMPANY",
	SOUS_ADMIN = "ROLE_SOUS_ADMIN",
}

export default Role
